import React from 'react'
import ApproverExpenseReports from 'src/app/ApproverExpenseReports/ApproverExpenseReports'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expensesOutOfPocketReportsAllRouteProps } from 'src/navigation/routeProps'

const ReimbursementsAppRoute: AppRoute = {
  id: AppLocation.AccountingReimbursements,
  routeProps: expensesOutOfPocketReportsAllRouteProps,
  component: <ApproverExpenseReports allExpenses />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ReimbursementsAppRoute
